// Fronted/src/components/admin/layout/AdminFooter.jsx
const AdminFooter = () => {
  return (
    <footer className="bg-white border-t px-6 py-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Excellent Love Ministries. All rights reserved.
        </p>
        <div className="flex space-x-6">
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700">Privacy</a>
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700">Terms</a>
        </div>
      </div>
    </footer>
  );
};

export default AdminFooter;